import { render, staticRenderFns } from "./tab-canceled.vue?vue&type=template&id=e23e9f0a&scoped=true"
import script from "./tab-canceled.vue?vue&type=script&lang=js"
export * from "./tab-canceled.vue?vue&type=script&lang=js"
import style0 from "./tab-canceled.vue?vue&type=style&index=0&id=e23e9f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23e9f0a",
  null
  
)

export default component.exports